import produce from 'immer'

import * as scimTokensCache from './scimTokensCache'

import {
  useScimPersonalAccessTokenCreateMutation,
  ScimPersonalAccessTokenCreateMutation,
  ScimPersonalAccessTokenCreateMutationVariables,
  ExecutionResult,
  MutationResult,
} from '@sketch/gql-types'

type UseCreateScimPersonalAccessTokenProps = {
  onCompleted: (
    data: ScimPersonalAccessTokenCreateMutation['scimPersonalAccessTokenCreate']
  ) => void
}

type WrappedMutation = (
  variables: ScimPersonalAccessTokenCreateMutationVariables
) => Promise<ExecutionResult<ScimPersonalAccessTokenCreateMutation>>

export const useCreateScimPersonalAccessToken = (
  props: UseCreateScimPersonalAccessTokenProps
): [WrappedMutation, MutationResult<ScimPersonalAccessTokenCreateMutation>] => {
  const { onCompleted } = props
  const [mutation, result] = useScimPersonalAccessTokenCreateMutation({
    onError: 'show-toast',
    onCompleted: data => onCompleted(data.scimPersonalAccessTokenCreate),
  })

  const wrappedMutation: WrappedMutation = async variables => {
    return await mutation({
      variables,
      update: (cache, { data, errors }) => {
        if (!data || (errors && errors.length > 0)) return

        const me = scimTokensCache.get(cache)
        if (!me) return

        const personalToken =
          data.scimPersonalAccessTokenCreate.personalAccessToken!

        const updatedMe = produce(me, user => {
          user.scimPersonalAccessTokens.unshift(personalToken)
        })

        scimTokensCache.set(cache, updatedMe)
      },
    })
  }

  return [wrappedMutation, result]
}
